export const STORES = {
  SK: 'stolarstvo-kaufmann.sk',
  EU: 'tischlerei-kaufmann.eu',
} as const;

export type Store = (typeof STORES)[keyof typeof STORES];

export function getCurrentStore(): Store | string | undefined {
  return process.env.NEXT_PUBLIC_CURRENT_STORE?.replace(/^api\./, '');
}

export function isSlovakStore(): boolean {
  return getCurrentStore() === STORES.SK;
}
